/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the WarehouseDTO interface.
 */
export function instanceOfWarehouseDTO(value) {
    return true;
}
export function WarehouseDTOFromJSON(json) {
    return WarehouseDTOFromJSONTyped(json, false);
}
export function WarehouseDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'] == null ? undefined : json['name'],
        'city': json['city'] == null ? undefined : json['city'],
        'state': json['state'] == null ? undefined : json['state'],
        'country': json['country'] == null ? undefined : json['country'],
    };
}
export function WarehouseDTOToJSON(json) {
    return WarehouseDTOToJSONTyped(json, false);
}
export function WarehouseDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'city': value['city'],
        'state': value['state'],
        'country': value['country'],
    };
}
